<template>
  <TMainForm :script-id="scriptId" :interception="interception" :buttons="buttons" :default-design="defaultDesign"
    ref="MainForm" :default-change-script="defaultChangeScript" :default-proccess-script="defaultProccessScript" />
</template>

<script setup>
/**
 * TTMLongStrokePumpDriverForm
 */
import TMainForm from './TMainForm.vue';
import { FORM_DESIGNS, FORM_CHANGE_SCRIPTS, FORM_PROCESS_SCRIPTS } from './constants';
import { ref, computed } from 'vue';

const props = defineProps({
  scriptId: { type: Number, default: null },
  interception: { type: [String, Object, Boolean], default: null },
});
const MainForm = ref(null);

const buttons = computed(() => [
  {
    key: 'LS_PUMP_DRIVER_START',
    index: 15,
    name: 'Запуск',
    click: () => MainForm.value?.write('LS_PUMP_DRIVER_START', 1),
  },
  {
    key: 'LS_PUMP_DRIVER_STOP',
    index: 16,
    name: 'Стоп',
    click: () => MainForm.value?.write('LS_PUMP_DRIVER_STOP', 1),
  },
  {
    key: 'LS_PUMP_DRIVER_RESET_ALARM',
    index: 11,
    name: 'Сброс аварии',
    click: () => MainForm.value?.write('LS_PUMP_DRIVER_RESET_ALARM', 1),
  },
]);

const defaultDesign = FORM_DESIGNS.TTMLongStrokePumpDriverForm;
const defaultChangeScript = FORM_CHANGE_SCRIPTS.TTMLongStrokePumpDriverForm;
const defaultProccessScript = FORM_PROCESS_SCRIPTS.TTMLongStrokePumpDriverForm;
</script>
